'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _field = require('./field');

Object.defineProperty(exports, 'Field', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_field)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/forms/index.js
 ** module id = 1003
 ** module chunks = 0
 **/